export default __webpack_public_path__ + "static/media/rac_logo.svg.d0dd04f4.svg";